// Favorieten (build 2.6): per trainer één document clubs/{clubId}/favorites/{uid}
// = { ids: [...] }. Alleen de trainer zelf leest en schrijft het.
// Sleutels: "lib:<id>" (lessen en oefeningen uit de bibliotheek, ook uit het seizoensplan),
// "deck:<sectie>:<id>" (Training Deck) en "note:<id>" (notities).
import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export async function loadFavs(clubId, uid) {
  var snap = await getDoc(doc(db, "clubs", clubId, "favorites", uid));
  var ids = snap.exists() ? snap.data().ids : null;
  return Array.isArray(ids) ? ids : [];
}
export function saveFavs(clubId, uid, ids) {
  return setDoc(doc(db, "clubs", clubId, "favorites", uid), { ids: ids });
}
export function libFavKey(it) { return "lib:" + it.id; }
export function deckFavKey(secId, drillId) { return "deck:" + secId + ":" + drillId; }
export function noteFavKey(n) { return "note:" + n.id; }
